import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { AppContext } from "../App";
import { getImageUrl } from "../pages/homepageUtils";

export default function HomepagePhoto({ d, eager = false }) {
  const strapiURL = useContext(AppContext);

  if (!d) {
    return null;
  }

  const imageUrl = getImageUrl(d, strapiURL);

  return (
    <Link to={`/collection/${d.documentId}`} className="retro-collection-tile">
      <div className="retro-collection-image">
        {imageUrl ? (
          <img loading={eager ? 'eager' : 'lazy'} decoding="async" src={imageUrl} alt={d.Name} />
        ) : (
          <span>Brak zdjęcia</span>
        )}
      </div>
      <div className="retro-collection-meta">
        <h3>{d.Name}</h3>
        <p>{d.kind?.Name || d.manufacturer?.Name || 'Eksponat'}</p>
      </div>
    </Link>
  );
}

